import styled from "styled-components";

import { truncateText } from "@similarweb/styles";
import { PopoverContent } from "@similarweb/ui-components";

export const StyledPopoverContent = styled(PopoverContent)`
    max-height: 320px;
    min-width: 320px;
    padding: 0;
    overflow-y: auto;
`;

export const StyledRecipientsTriggerText = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: calc(100% - 32px);

    span {
        display: block;
        max-width: 100%;
        ${truncateText()}
    }
`;

export const StyledRecipientsDropdownItem = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 282px;

    span {
        display: block;
        max-width: 100%;
        ${truncateText()}
    }
`;
